// ANGULAR
import { Routes } from '@angular/router';
// COMPONENTS
import { LoginComponent } from '@features/login/login.component';
import { HomeComponent } from '@features/home/home.component';
import { ChangePasswordRequiredComponent } from '@features/change-password-required/change-password-required.component';
// GUARDS
import { AuthGuard } from '@guards/auth.guard';
// OTHERS
import { Paths } from '@constants/paths.const';

export const routes: Routes = [
  { path: Paths.login, component: LoginComponent },
  { path: Paths.home, component: HomeComponent, canActivate: [AuthGuard] },
  { path: Paths.changePasswordRequired, component: ChangePasswordRequiredComponent, canActivate: [AuthGuard] },
  { path: '', redirectTo: Paths.login, pathMatch: 'full' },
  { path: '**', redirectTo: Paths.login, pathMatch: 'full' },
];